import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { GlobalService } from 'src/app/core/service/global.service';
import { getProfileData } from 'src/app/core/state/profile';

@Component({
  selector: 'app-news-preference',
  templateUrl: './news-preference.component.html',
  styleUrls: ['./news-preference.component.scss']
})
export class NewsPreferenceComponent implements OnInit {
 @Input() modalRef: any;
  @Input('industries') industries: any[] = [];
   @Input('selectedIndustries') selectedIndustries: any[] = [];
  public getProfileData$: Observable<IProfileDetails>;
  private destroyed$: Subject<void> = new Subject();
  profileData: IProfileDetails;
  selected: string[] = [];
  constructor( private globalService: GlobalService,private readonly store: Store,) { }

  ngOnInit(): void {
      this.getProfileData$ = this.store.pipe(select(getProfileData));
    this.getProfileData$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
          if (res) {
            this.profileData = res;}
          })
    console.log(this.selectedIndustries, "selectedIndustries");
     if (this.selectedIndustries && this.selectedIndustries.length > 0) {
    this.selected = [...this.selectedIndustries];
  }
  }
 
  toggleSelection(id: string) {
    if (this.selected.includes(id)) {
      this.selected = this.selected.filter(x => x !== id);
    } else {
      this.selected.push(id);
    }
  }

  isChecked(id: string): boolean {
    return this.selected.includes(id);
  }

  save() {
    const postData ={
      categories: this.selected
    }
  this.globalService.OnMyPreference(postData, this.profileData.profileId, this.profileData.accountType).subscribe((res) => {
   console.log(res, "preference response");

    this.modalRef.close(this.selected);
     });
  }

  close() {
    this.modalRef.dismiss();
  }
}
